import {observable, decorate} from "mobx";
import {PabsOnlineRole} from "../../Enums/constants";

class UserStore {
    /**
     * @type {null} For Pabs, see PabsUserDto
     */
    accountInfo = null;
    showMorningstarMessage = false;

    /**
     * Pabs isTokenUserForPlan.
     * If IsTokenUser == true, it means that the user is a Limited User restricted by roles
     * If IsTokenUser == false, it means that the user is a PlanAdministrator
     * @param planId the orgId/SystemId
     */
    isTokenUserForPlan(planId) {
        return this.accountInfo?.permissions[planId]?.isTokenUser ?? false;
    }
    
    /**
     * Pabs isPrimaryContactForPlan
     * @param planId the orgId/SystemId
     */
    isPrimaryContactForPlan(planId) {
        const isCemAdmin = this.accountInfo?.isAdmin ?? false;
        const isAnalyst = this.accountInfo?.isAnalyst ?? false;
        const isPlanAdmin = this.isPlanAdministrator(planId);
        const isPrimaryContact = this.accountInfo
            ?.permissions[planId]
            ?.roles
            ?.includes(PabsOnlineRole.PabsPrimaryContactUser) ?? false;
        
        return (isPlanAdmin && isPrimaryContact) || isAnalyst || isCemAdmin;
    }
    
    /**
     * Pabs isUserPlanAdministrator
     * @param planId the orgId/SystemId
     */
    isPlanAdministrator(planId) {
        const isCemAdmin = this.accountInfo?.isAdmin ?? false;
        const isAnalyst = this.accountInfo?.isAnalyst ?? false;
        return !this.isTokenUserForPlan(planId) || isAnalyst || isCemAdmin;
    }
}

decorate(UserStore, {
    accountInfo: observable,
    showMorningstarMessage: observable
});

export default new UserStore();